import { connect } from 'react-redux';
import classnames from 'classnames';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { isPreviewHover, isVideosListInfoAlwaysShown, isVideosListInfoNeverShown } from 'shared/selectors/app-settings';
import getPlayButtonConfigForVideo from 'widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/play/button-config';
import getPaidAccessButtonConfigForVideo from 'widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/paid-access/button-config';
import { getVideoCoverUrl } from 'shared/ui-selectors/video/cover';

import { OverlayBase } from 'widget/views/desktop/compact/components/player-overlay/overlay';

import styles from './video-thumbnail-overlay.styl';


@connect((state, ownProps) => ({
  playButtonConfig: getPlayButtonConfigForVideo(ownProps),
  paidAccessButtonConfig: getPaidAccessButtonConfigForVideo(ownProps),
  canShowMainItemTitle: true,
  isMainActionsOnlyIcons: true,

  isPreviewHover: isPreviewHover(state),
  isOverlayAlwaysShown: isVideosListInfoAlwaysShown(state),
  isOverlayNeverShown: isVideosListInfoNeverShown(state),
}))
@VODCSSModules(styles)
export default class VideoThumbnailOverlay extends OverlayBase {
  static displayName = 'VideoThumbnailOverlay';

  static propTypes = {
    onClick: React.PropTypes.func,
    isPreviewHover: React.PropTypes.bool,
    isOverlayAlwaysShown: React.PropTypes.bool,
    isOverlayNeverShown: React.PropTypes.bool,
  };

  get titleText() {
    const { videoItem } = this.props;

    return videoItem.title;
  }

  get coverUrl() {
    const { videoItem } = this.props;

    return getVideoCoverUrl(videoItem);
  }

  render() {
    const {
      channelData,
      videoItem,
      className,
      isOverlayNeverShown,
      isOverlayAlwaysShown,
      isPreviewHover,
      onClick,
      } = this.props;

    if (!channelData || !videoItem) {
      return null;
    }

    const styleNames = classnames('container', {
      'always-hidden': isOverlayNeverShown,
      'always-visible': isOverlayAlwaysShown,
      'preview-hover': isPreviewHover,
    });

    return (
      <div styleName="wrapper"
           onClick={onClick}
           data-hook="videoListThumb">
        {this.cover}
        <div styleName={styleNames}
             className={className}>
          <div styleName="content">
            <div styleName="top-content"
                 dir="ltr">
              <div styleName="title-block">
                {this.title}
              </div>
              {this.buttons}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/video-thumbnail-overlay/video-thumbnail-overlay.js